import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h2>
            Pure<span>Eng</span>
          </h2>

          <p>معاك خطوة بخطوة عشان تفهم الإنجليزي وتحقق أفضل نتيجة.</p>
        </div>

        <div className="footer-links">
          <Link to="/">الرئيسية</Link>
          <Link to="/lessons">الدروس</Link>
          <Link to="/exams">الامتحانات</Link>
          <a href="#contact">تواصل معانا</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {currentYear} PureEng. جميع الحقوق محفوظة.</p>

        <p>Made with ❤️ for Egyptian students</p>
      </div>
    </footer>
  );
}
